import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Constants from '../../constants/Constants';

const ItemCounterButton = (props) => {
    const {
        updateCurrentValue
    } = props;
    let [counter, setCounter] = useState(props.counter);

     /**
     * Increment the counter and set the state
     */
    const increment = () => {
        if(counter < Constants.SHOP. MAX_QUANTITY_PER_ITEM) {
            counter++;
            setCounter(counter);
            updateCurrentValue(counter);
        }
    }

    /**
     * Decrement the counter and set the state
     */
    const decrement = () => {
        if(counter > 0) {
            counter--
            setCounter(counter);
            updateCurrentValue(counter);
        }
    }

    return (
        <div className="flex flex-row h-10 w-full rounded-lg bg-transparent mt-1">
            <button className=" bg-gray-100 text-gray-600  hover:bg-gray-200 h-full w-10 rounded-l cursor-pointer outline-none"
                onClick={decrement}    
            >
                <span className="m-auto text-2xl font-thin">−</span>
            </button>
            <div className="text-center bg-gray-100 font-semibold text-md md:text-basecursor-default  w-10 p-2 text-gray-700">{counter}</div>
            <button className="bg-gray-100 text-gray-600  hover:bg-gray-200 h-full w-10 rounded-r cursor-pointer"
                onClick={increment}    
            >
                <span className="m-auto text-2xl font-thin">+</span>
            </button>
        </div>
    )
}

ItemCounterButton.propTypes = {
    counter : PropTypes.number,
    updateCurrentValue : PropTypes.func
};


export default ItemCounterButton;





